import { IUIConfig } from "../data/interface";

export async function fetchUIConfig(): Promise<IUIConfig> {
  // Always fetch fresh config: no-store bypasses the browser HTTP cache, and the
  // cache-busting query string defeats an edge (CloudFront) cache that ignores
  // request cache directives.
  const res = await fetch(`${window.location.origin}/data/config.json?t=${Date.now()}`, {
    method: "GET",
    cache: "no-store",
    headers: {
      "Accept": "application/json"
    },
  });
  if (res.ok) {
    return res.json() as Promise<IUIConfig>;
  }
  throw new Error(res.statusText)
}
